import React from 'react';
import { componentService } from 'js/services/component.service';

export const CloseGamblingSession = React.lazy(() => import(/* webpackChunkName: "close-gambling-session" */ './CloseGamblingSession'));

// <hub2-close-gambling-session></hub2-close-gambling-session>
componentService.registerWebContentComponents({ CloseGamblingSession });
